const API_BASE = '/api'

async function request(method, path, body = null) {
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  }
  if (body) opts.body = JSON.stringify(body)
  
  const res = await fetch(`${API_BASE}${path}`, opts)
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Request failed' }))
    throw new Error(err.detail || 'Request failed')
  }
  return res.json()
}

export const api = {
  async register(username, password) {
    return request('POST', '/auth/register', { username, password })
  },
  
  async login(username, password) {
    return request('POST', '/auth/login', { username, password })
  },
  
  async logout() {
    return request('POST', '/auth/logout')
  },
  
  async me() {
    return request('GET', '/auth/me')
  },

  async changePassword(currentPassword, newPassword) {
    return request('POST', '/auth/change-password', { current_password: currentPassword, new_password: newPassword })
  },
  
  async listVault() {
    return request('GET', '/vault')
  },
  
  async getBlob(id) {
    return request('GET', `/vault/${id}`)
  },
  
  async createBlob(blob) {
    return request('POST', '/vault', blob)
  },
  
  async updateBlob(id, blob) {
    return request('PUT', `/vault/${id}`, blob)
  },
  
  async deleteBlob(id) {
    return request('DELETE', `/vault/${id}`)
  },

  async getTrash() {
    return request('GET', '/vault/trash')
  },

  async restoreBlob(id) {
    return request('POST', `/vault/${id}/restore`)
  },

  async permanentDeleteBlob(id) {
    return request('DELETE', `/vault/${id}/permanent`)
  },

  async exportVault() {
    return request('GET', '/vault/export')
  },

  async importVault(entries) {
    return request('POST', '/vault/import', { entries })
  }
}